module.exports = __webpack_public_path__ + "img/map-balkam.6d349542.svg";